import { MatDialogConfig } from '@angular/material/dialog';
import { UV_MOBILE_QUERY } from '../services/platform.service';

// On a phone, focusing a field raises the keyboard over half the sheet before
// the form has been seen: dialogs start from their title there, and the
// keyboard comes up when a field is tapped. MatDialog spreads these defaults on
// every open, so the getter is read per dialog and follows rotation.
export const DIALOG_DEFAULT_OPTIONS: MatDialogConfig = {
  ...new MatDialogConfig(),
  get autoFocus(): MatDialogConfig['autoFocus'] {
    return window.matchMedia(UV_MOBILE_QUERY).matches ? 'first-heading' : 'first-tabbable';
  }
};
